import $ from 'jquery';

$('.deprecated-projects__detail-link').on('click', function (e) {
    e.preventDefault();
    console.log($('body').find('.project-popup').length);
    if($('body').find('.project-popup').length < 1)  {
        $('body').append('<div class="project-popup"><i class="project-popup__loader fas fa-spinner fa-pulse"></i><div class="project-popup__bg"></div><div class="project-popup__content container"><div class="project-popup__inner-content"></div></div></div>');
        $('html').css('padding-right', window.innerWidth - document.documentElement.clientWidth);
        $('html,body').css('overflow','hidden');
        let href = $(this).attr('href');
        $.ajax($(this).attr('href')).done(function (data) {
            var detail = $(data).find('.project-detail');
            var closeIcon = $('.deprecated-projects').data('close-icon') || '/typo3conf/ext/lfmsite/Resources/Public/Icons/Close.svg';
            $('body').find('.project-popup .project-popup__inner-content').append('<img class="project-popup__close" src="' + closeIcon + '" alt="Schliessen"/>');
            $('body').find('.project-popup .project-popup__inner-content').append(detail);
            $('body').find('.project-popup .project-popup__loader ').remove();

            window.history.pushState('','', href);
        })
    }
})

$('body').on('click', '.project-popup__close', function () {
    $('.project-popup').remove();
    $('html,body').removeAttr('style');
    window.history.back();
})

$('.deprecated-projects__show-all').on('click', function (e) {
    e.preventDefault();
    $(this).siblings('.deprecated-projects__table').addClass('deprecated-projects__table--show-all')
    $(this).remove();
})

if($('.project').length >= 1) {
    var currentPage = 1;
    var itemsPerPage = 1;
    var items = $('.project').find('.project__item-wrap');
    var maxPages = Math.ceil(items.length / itemsPerPage);

    handleShownItems();

    $('.project .project__next').on('click', function (e) {
        e.preventDefault();
        nextPage();
    })

    $('.project .project__prev').on('click', function (e) {
        e.preventDefault();
        prevPage();
    })

    $(window).on('resize',function () {
        handleShownItems();
    })
}


function nextPage() {
    if(currentPage < maxPages) {
        currentPage++;
        handleShownItems();
    }
}

function prevPage() {
    if(currentPage > 1) {
        currentPage--;
        handleShownItems();
    }
}

function handleShownItems() {
    if($(window).innerWidth() > 1339) {
        itemsPerPage = 6;
    } else if ($(window).innerWidth() > 991) {
        itemsPerPage = 4;
    } else {
        itemsPerPage = 1
    }

    if(items.length <= itemsPerPage) {
        $('.project__pagination').addClass('project__pagination--hide')
    } else {
        $('.project__pagination').removeClass('project__pagination--hide')
    }

    maxPages = Math.ceil(items.length / itemsPerPage);

    $('.project__pagination-current-page').text(currentPage);
    $('.project__pagination-max-pages').text(maxPages);
    items.removeClass('project__item-wrap--show')
    var shownItems = items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
    shownItems.addClass('project__item-wrap--show');
}

$('.project__items').on('touchstart', function (e) {
    handleTouchStart(e);
})
$('.project__items').on('touchmove', function (e) {
    handleTouchMove(e);
})

var xDown = null;
var yDown = null;

function getTouches(evt) {
    return evt.touches ||             // browser API
        evt.originalEvent.touches; // jQuery
}

function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
}

function handleTouchMove(evt) {
    if ( ! xDown || ! yDown ) {
        return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
        if ( xDiff > 0 ) {
            nextPage();
        } else {
            prevPage();
        }
    }
    xDown = null;
    yDown = null;
}


var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1;

if(isSafari) {
    $('.form-download-link').attr('download','download');
}